import React, { useRef, useState, useEffect } from "react";
import { Card, Image, Tabs, Tab } from "react-bootstrap";
import { changeLanguage, setAppPage } from "../../store/actions/actions";
import { connect } from "react-redux";

import LeftBar from "../Project/Dashboard/LeftBar";
import NavBar from "../Project/Dashboard/NavBar";

import Chat from "../Project/Dashboard/Chat";
import * as ProjectStyle from "../Project/project.module.css";
import { useHistory, useParams } from "react-router";
import firebase from "firebase";
import { useCollection } from "react-firebase-hooks/firestore";
import { useMemo } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder } from "@fortawesome/free-solid-svg-icons";

function Folder() {
  const history = useHistory();

  const [folderDataSnapshot, folderDataLoading, folderDataError] =
    useCollection(
      firebase
        .firestore()
        .collection(
          "/workspaces/LgT2sjzoZQwwKMGPnob2/rooms/I5ZwggPkyQpeCdRpcl1M/folders"
        )
        .orderBy("timestamp", "desc")
    );

  const folderData = useMemo(() => {
    return folderDataSnapshot?.docs?.map((e) => {
      return { id: e.id, ...e.data() };
    });
  }, [folderDataSnapshot]);

  return (
    <>
      <div className="h-100">
        <LeftBar mobile />
        <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
          <NavBar />
          <div className="row" style={{ height: "95vh", overflow: "hidden" }}>
            <LeftBar />
            <div
              className="col-md-7 h-100 p-md-5 p-3 bg-graphite"
              style={{ overflow: "scroll" }}
            >
              <div className=" bg-graphite ">
                <div className="">
                  <div className="d-flex align-items-center rounded border border-dark">
                    <img
                      src={
                        "data:image/png;base64,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"
                      }
                      className={`bg-dark p-1 ${ProjectStyle.app_icon_image}`}
                      alt=""
                    />
                    <h3 className="font-weight-bold text-white mx-2 mb-0">
                      Folders
                    </h3>
                  </div>
                  {folderData?.map((item) => (
                    <Card className="bg-dark text-white my-3">
                      <Card.Header className="d-flex align-items-start">
                        <div className="d-flex">
                          <div
                            className="img-fluid rounded-circle shadow-sm"
                            style={{
                              height: 50,
                              width: 50,
                              backgroundImage: `url(${item?.user?.avatar})`,
                              backgroundPosition: "center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div className="ml-2">
                            <div className="d-flex align-items-center">
                              <p className="mb-0 mr-2">{item?.user?.name}</p>
                              <p className="mb-0 small text-muted"></p>
                            </div>
                            <p className="mb-0 small text-muted">
                              {moment(item?.timestamp).format("LLL")}
                            </p>
                          </div>
                        </div>
                      </Card.Header>
                      <Card.Body className="py-1">
                        <div
                          className="d-flex my-2"
                          onClick={() => history.push(`folder/${item.id}`)}
                        >
                          <FontAwesomeIcon
                            icon={faFolder}
                            className="text-primary"
                            size="2x"
                          />
                          <div className="ml-2">
                            <div className="d-flex align-items-center">
                              <p className="mb-0 mr-2">{item?.folderName}</p>
                              <p className="mb-0 small text-muted"></p>
                            </div>
                            <p className="mb-0 small text-muted">
                              {item?.folderDesignation}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}

                  <div className="mt-3 mt-md-4">
                    <div className="mb-3 mb-md-5"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* Chat module */}
            <div
              className="col-md-4 h-100 px-0 d-flex flex-column justify-content-between"
              style={{ overflow: "scroll" }}
            >
              <Chat />
            </div>
            {/* Chat module ends */}
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
    app: state.app,
  }),
  { changeLanguage, setAppPage }
)(Folder);
